import { isSlideComponentHkcsEnQ1, isSlideComponentHkcsEnQ2, isSlideComponentHkcsQ1, isSlideComponentHkcsQ2, isSlideComponentHkcsQ3, Question } from '@/types/slide';
import React, { useCallback } from 'react';
import { ResultContentHkcsEnQ1 } from './legacy/contents/ResultContentHkcsEnQ1.legacy';
import { ResultContentHkcsEnQ2 } from './legacy/contents/ResultContentHkcsEnQ2.legacy';
import { ResultContentHkcsQ1 } from './legacy/contents/ResultContentHkcsQ1.legacy';
import { ResultContentHkcsQ2 } from './legacy/contents/ResultContentHkcsQ2.legacy';
import { ResultContentHkcsQ3 } from './legacy/contents/ResultContentHkcsQ3.legacy';
import { ResultContentUnsupported } from './legacy/contents/ResultContentUnsupported';
import { PropsWithOnLoad } from './type';

export type ResultContentProps = PropsWithOnLoad & {
    question: Question;
};

export const ExportableResultSlide: React.FC<ResultContentProps> = ({ question, onLoad }) => {
    const RenderResultSlide = useCallback(() => {
        switch (question.type) {
            case 'hkcsQ1':
                return isSlideComponentHkcsQ1(question) ? <ResultContentHkcsQ1 question={question} onLoad={onLoad} /> : null;
            case 'hkcsQ2':
                return isSlideComponentHkcsQ2(question) ? <ResultContentHkcsQ2 question={question} onLoad={onLoad} /> : null;
            case 'hkcsQ3':
                return isSlideComponentHkcsQ3(question) ? <ResultContentHkcsQ3 question={question} onLoad={onLoad} viewOnly={true} /> : null;
            case 'hkcsEnQ1':
                return isSlideComponentHkcsEnQ1(question) ? <ResultContentHkcsEnQ1 question={question} onLoad={onLoad} viewOnly={true} /> : null;
            case 'hkcsEnQ2':
                return isSlideComponentHkcsEnQ2(question) ? <ResultContentHkcsEnQ2 question={question} onLoad={onLoad} viewOnly={true} /> : null;
            default:
            case 'character':
                /**
                 * Note that ResultContentCharacter onLoad is not fully implemented yet not all components within it can be exportable.
                 *
                 * return <ResultContentCharacter question={question} onLoad={onLoad} viewOnly={true} />;
                 */
                return <ResultContentUnsupported onLoad={onLoad} />;
        }
    }, [onLoad, question]);

    return <RenderResultSlide />;
};
